import NavigationSection from "../navigation-section"

const debug = false
// const debug = "navigation_replaceSection"

export default function navigation_replaceSection(sectionToReplace: NavigationSection, newSection: NavigationSection) {

    debug && console.log(debug, 'process', newSection, sectionToReplace)

    const navigationStructure = gd.layout.navigation.navigationStructure

    navigationStructure.debug()

    newSection.sortPosition = sectionToReplace.sortPosition
    navigationStructure.replace(sectionToReplace.id, newSection)

    navigationStructure.regenerateSortPositions()
    navigationStructure.sort()
    navigationStructure.debug()
    navigationStructure.saveSortPositions()
    navigationStructure.savePositions() // save to gd.user.settings.navigation.buttonPositions

    // apply app specific navigation behaviour
    const app: any = gd.getMainApp()
    if (app?.updateMainNavigation) app.updateMainNavigation()

    gd.layout.navigation.reRender("CustomView on add to panel")
    gd.layout.currentMenu?.reRender()
}
